import { render, staticRenderFns } from "./AssetsFilters.vue?vue&type=template&id=0bb919a0&scoped=true&"
import script from "./AssetsFilters.vue?vue&type=script&lang=js&"
export * from "./AssetsFilters.vue?vue&type=script&lang=js&"
import style0 from "./AssetsFilters.vue?vue&type=style&index=0&id=0bb919a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb919a0",
  null
  
)

export default component.exports